/**
 * EL FORMULARIO DE APLICACION DE AUTO, TAL COMO ELLA LO PIDE.
 *
 * Lissette, 2026-09-04, punto 69: *"te dejare una form de aplicacion de auto,
 * adaptala asi tal cual a nuestro sistema con la misma pregunta y manera, y
 * ademas poder agregar mas dependiente y mas carro"*.
 *
 * El archivo que mando (`AutoQuoteForm`) es una hoja de calculo con seis
 * bloques y una hoja "Menus" con los desplegables. Aqui estan los mismos
 * campos, en el mismo orden y con las mismas opciones — pero con la unica
 * diferencia que ella pidio expresamente: la hoja tenia CUATRO columnas de
 * carro y TRES bloques de conductor, y aqui se agregan los que hagan falta.
 *
 * ── POR QUE UN CATALOGO Y NO CAMPOS SUELTOS EN LA PANTALLA ──────────────────
 *
 * Los mismos campos hacen falta en cuatro sitios: el formulario que rellena el
 * cliente, la vista previa que ve la agente antes de enviarlo, la validacion
 * del servidor y la pantalla donde se leen las respuestas. Escribirlos cuatro
 * veces es como se pierde una opcion en silencio (la trampa de CLAUDE.md: una
 * opcion del formulario sin valor en el servidor se guarda vacia sin dar
 * ningun error). Se declaran UNA vez y los cuatro leen de aqui.
 *
 * ── LOS DESPLEGABLES SON LOS DE ELLA ────────────────────────────────────────
 *
 * Cada `opciones` sale de la validacion de datos de su hoja, con las mismas
 * palabras. Lo que se guarda es SIEMPRE el texto en ingles (`v`), que es el que
 * viaja a la aseguradora; `es`/`en` es solo como se le enseña al cliente. Asi
 * la misma respuesta se lee igual venga el formulario en el idioma que venga.
 *
 * Modulo sin React a proposito: se prueba sin montar la pantalla.
 */

// ── Desplegables (hoja "Menus" y las validaciones de la hoja 1) ────────────

export const GENEROS = [
  { v: 'MALE', es: 'Masculino', en: 'Male' },
  { v: 'FEMALE', es: 'Femenino', en: 'Female' },
];

export const ESTADO_CIVIL = [
  { v: 'Single', es: 'Soltero/a', en: 'Single' },
  { v: 'Married', es: 'Casado/a', en: 'Married' },
  { v: 'Separated', es: 'Separado/a', en: 'Separated' },
  { v: 'Divorced', es: 'Divorciado/a', en: 'Divorced' },
  { v: 'Widowed', es: 'Viudo/a', en: 'Widowed' },
  { v: 'Domestic Partner', es: 'Pareja de hecho', en: 'Domestic Partner' },
];

export const EDUCACION = [
  { v: '< High School', es: 'Sin secundaria', en: '< High School' },
  { v: 'GED', es: 'GED', en: 'GED' },
  { v: 'High School', es: 'Secundaria', en: 'High School' },
  { v: 'Some College', es: 'Universidad sin terminar', en: 'Some College' },
  { v: 'Community College', es: 'Community College', en: 'Community College' },
  { v: "Bachelor's Degree", es: 'Licenciatura', en: "Bachelor's Degree" },
  { v: "Master's Degree", es: 'Maestría', en: "Master's Degree" },
  { v: 'Ph. D', es: 'Doctorado', en: 'Ph. D' },
  { v: 'Medical Degree', es: 'Título de Medicina', en: 'Medical Degree' },
  { v: 'Law Degree', es: 'Título de Derecho', en: 'Law Degree' },
];

export const TIPO_DE_RESIDENCIA = [
  { v: 'Single Family', es: 'Casa unifamiliar', en: 'Single Family' },
  { v: 'Apartment', es: 'Apartamento', en: 'Apartment' },
  { v: 'Condominium', es: 'Condominio', en: 'Condominium' },
  { v: 'Townhouse', es: 'Townhouse', en: 'Townhouse' },
  { v: 'Other', es: 'Otro', en: 'Other' },
];

export const DUENO_O_INQUILINO = [
  { v: 'Owner', es: 'Dueño/a', en: 'Owner' },
  { v: 'Rented/Lease', es: 'Alquilado / arrendado', en: 'Rented/Lease' },
];

export const TENENCIA_DEL_CARRO = [
  { v: 'Owned', es: 'Propio', en: 'Owned' },
  { v: 'Leased', es: 'Arrendado (lease)', en: 'Leased' },
  { v: 'Financed', es: 'Financiado', en: 'Financed' },
];

export const PARENTESCO = [
  { v: 'Spouse', es: 'Cónyuge', en: 'Spouse' },
  { v: 'Parent', es: 'Padre / madre', en: 'Parent' },
  { v: 'Child', es: 'Hijo/a', en: 'Child' },
  { v: 'Domestic Partner', es: 'Pareja de hecho', en: 'Domestic Partner' },
  { v: 'Other', es: 'Otro', en: 'Other' },
];

export const TERMINO_DE_POLIZA = [
  { v: 'Annual', es: 'Anual', en: 'Annual' },
  { v: 'Semi-Annual', es: 'Semestral', en: 'Semi-Annual' },
  { v: 'Quarterly', es: 'Trimestral', en: 'Quarterly' },
  { v: 'Monthly', es: 'Mensual', en: 'Monthly' },
];

export const PLAN_DE_COBRO = [
  { v: 'Full Payment', es: 'Pago completo', en: 'Full Payment' },
  { v: 'Quarterly', es: 'Trimestral', en: 'Quarterly' },
  { v: 'Monthly', es: 'Mensual', en: 'Monthly' },
];

export const FORMA_DE_PAGO = [
  { v: 'EFT (Cuenta Banco)', es: 'EFT (cuenta de banco)', en: 'EFT (bank account)' },
  { v: 'Credit/Debit Card', es: 'Tarjeta de crédito / débito', en: 'Credit/Debit Card' },
  { v: 'Cash/Check', es: 'Efectivo / cheque', en: 'Cash/Check' },
  { v: 'Other', es: 'Otro', en: 'Other' },
];

export const SI_O_NO = [
  { v: 'YES', es: 'Sí', en: 'Yes' },
  { v: 'NO', es: 'No', en: 'No' },
];

// ── Los bloques del formulario ────────────────────────────────────────────
//
// `tipo`: 'texto' | 'fecha' | 'numero' | 'lista'. Nada mas hace falta: la hoja
// de ella no tiene un solo campo que no sea una de esas cuatro cosas.

/** Lo del TITULAR que no cabe en los datos de siempre (nombre, correo, teléfono…). */
export const CAMPOS_CONDUCTOR_TITULAR = [
  { key: 'genero', es: 'Género', en: 'Gender', tipo: 'lista', opciones: GENEROS },
  { key: 'licencia', es: 'Número de licencia de conducir', en: "Driver's License Number", tipo: 'texto' },
  { key: 'ocupacion', es: 'Ocupación', en: "Driver's Occupation", tipo: 'texto' },
  { key: 'educacion', es: 'Nivel de educación', en: 'Education Level', tipo: 'lista', opciones: EDUCACION },
];

/**
 * LO QUE SE PREGUNTA CON LA DIRECCIÓN, aunque el dato viva en el conductor.
 *
 * Lissette, 2026-09-09: *"subir la información de Residence Type, Owner/Tenant
 * and Time at Address arriba a la sección de Address"*. Tiene razón: quien
 * está llenando su dirección ya tiene la cabeza en su casa; preguntárselo
 * treinta preguntas más abajo, mezclado con la licencia de conducir, obliga a
 * volver a pensar en lo mismo dos veces.
 *
 * Y el 2026-09-13, la misma queja con otro campo: *"en la aplicación de carro
 * el condado está saliendo abajo y no en la parte de direcciones"*. El
 * **condado** es dirección —es la parte del domicilio que la gente menos se
 * sabe de memoria, y se contesta mirando el mismo sobre del que se copió la
 * calle—, así que se sube aquí, el PRIMERO del bloque: justo debajo del código
 * postal, que es donde la cabeza ya está.
 *
 * Por eso la lista dejó de llamarse "de vivienda": el condado no es una
 * característica de la casa, y un nombre que describe a tres de sus cuatro
 * campos es el que hace que el quinto acabe en la lista equivocada.
 *
 * El DATO no se mueve: se sigue guardando dentro del conductor titular, así
 * que una aplicación enviada antes de este cambio se lee igual y no hay nada
 * que migrar. Lo único que cambia es DÓNDE se pregunta.
 */
export const CAMPOS_CON_LA_DIRECCION = [
  { key: 'condado', es: 'Condado', en: 'County', tipo: 'texto' },
  { key: 'tipoResidencia', es: 'Tipo de vivienda', en: 'Residence Type', tipo: 'lista', opciones: TIPO_DE_RESIDENCIA },
  { key: 'duenoOInquilino', es: '¿Dueño o alquilado?', en: 'Owner / Tenant', tipo: 'lista', opciones: DUENO_O_INQUILINO },
  { key: 'tiempoEnDireccion', es: 'Tiempo en la dirección', en: 'Time at Address', tipo: 'texto' },
];

/** Retirado del TITULAR: ver CAMPOS_CONDUCTOR_RETIRADOS abajo, mismo motivo. */
export const CAMPOS_CONDUCTOR_TITULAR_RETIRADOS = [
  { key: 'segundoApellido', es: '2.º apellido', en: '2nd Last Name', tipo: 'texto' },
];

/** UN carro. La hoja traía cuatro columnas; aquí se agregan los que hagan falta. */
export const CAMPOS_CARRO = [
  { key: 'vin', es: 'Número de VIN', en: 'VIN Number', tipo: 'texto' },
  { key: 'anio', es: 'Año del carro', en: 'Year of Car', tipo: 'numero' },
  { key: 'anioCompra', es: 'Año en que lo compró', en: 'Year Purchased', tipo: 'numero' },
  { key: 'millasAnuales', es: 'Millas al año', en: 'Miles Driven Annually', tipo: 'numero' },
  { key: 'tenencia', es: '¿Propio, arrendado o financiado?', en: 'Owned, Leased or Financed', tipo: 'lista', opciones: TENENCIA_DEL_CARRO },
];

/**
 * UN conductor adicional. La hoja traía tres bloques; aquí se agregan los que
 * hagan falta.
 *
 * SIN "SEGUNDO NOMBRE" (Lissette, 2026-09-08: *"en la aplicación de auto no
 * coloques middle name, solo nombre y apellido"*). El "middle name" es un
 * invento estadounidense que sus clientes no tienen: lo que sí tienen es un
 * SEGUNDO APELLIDO, que se sigue preguntando justo debajo. Preguntar los dos
 * es la receta para que el segundo apellido acabe escrito en la casilla del
 * medio — que es exactamente el enredo de nombres que ya costó reparar 1.746
 * fichas a mano (2026-08-15).
 */
export const CAMPOS_CONDUCTOR = [
  { key: 'firstName', es: 'Nombre', en: 'First Name', tipo: 'texto' },
  { key: 'lastName', es: 'Apellido', en: 'Last Name', tipo: 'texto' },
  { key: 'dateOfBirth', es: 'Fecha de nacimiento', en: 'Date of Birth', tipo: 'fecha' },
  { key: 'genero', es: 'Género', en: 'Gender', tipo: 'lista', opciones: GENEROS },
  { key: 'parentesco', es: 'Parentesco con el titular', en: 'Relationship to Client', tipo: 'lista', opciones: PARENTESCO },
  { key: 'estadoCivil', es: 'Estado civil', en: 'Marital Status', tipo: 'lista', opciones: ESTADO_CIVIL },
  { key: 'licencia', es: 'Número de licencia de conducir', en: "Driver's License Number", tipo: 'texto' },
  { key: 'ocupacion', es: 'Ocupación', en: "Driver's Occupation", tipo: 'texto' },
  { key: 'educacion', es: 'Nivel de educación', en: 'Education Level', tipo: 'lista', opciones: EDUCACION },
];

/**
 * CAMPOS QUE YA NO SE PREGUNTAN, pero que puede traer una aplicación enviada
 * ANTES de quitarlos.
 *
 * La pantalla que enseña una aplicación recibida pinta los campos de ESTE
 * catálogo, no las claves que trae el archivo: borrar un campo de la lista de
 * arriba, sin más, deja el dato guardado en la base pero INVISIBLE para quien
 * abre la aplicación. Un nombre que desaparece de la pantalla y sigue en la
 * base es peor que un nombre que no se preguntó nunca.
 *
 * Por eso se retiran aquí: el formulario deja de preguntarlos y la vista
 * previa deja de anunciarlos, pero si una aplicación vieja los trae escritos
 * se siguen viendo.
 */
export const CAMPOS_CONDUCTOR_RETIRADOS = [
  { key: 'middleName', es: 'Segundo nombre', en: 'Middle Name', tipo: 'texto' },
  // Lissette, 2026-09-09: *"sigo viendo 2 last name, quitamos"*. Cuando pidio
  // "solo nombre y apellido" se quito el segundo NOMBRE y se quedo el segundo
  // APELLIDO, que en la pantalla en ingles sale como "2nd Last Name" — o sea,
  // lo mismo que ella estaba viendo y pidiendo quitar.
  { key: 'segundoApellido', es: '2.º apellido', en: '2nd Last Name', tipo: 'texto' },
];

/** UNA dirección anterior. La hoja traía dos; aquí se agregan las que hagan falta. */
export const CAMPOS_DIRECCION_ANTERIOR = [
  { key: 'direccion', es: 'Dirección anterior', en: 'Previous Address', tipo: 'texto' },
  { key: 'tiempo', es: 'Tiempo en esa dirección', en: 'Time at Address', tipo: 'texto' },
];

export const CAMPOS_SEGURO_ACTUAL = [
  { key: 'compania', es: 'Compañía actual', en: 'Company Name', tipo: 'texto' },
  { key: 'numeroPoliza', es: 'Número de póliza', en: 'Policy Number', tipo: 'texto' },
  { key: 'vencimiento', es: 'Fecha de vencimiento', en: 'Expiration Date', tipo: 'fecha' },
  { key: 'tiempoContinuo', es: 'Tiempo de cobertura continua', en: 'Length of Continuous Coverage', tipo: 'texto' },
];

export const CAMPOS_POLIZA_AUTO = [
  { key: 'termino', es: 'Término de la póliza', en: 'Policy Term', tipo: 'lista', opciones: TERMINO_DE_POLIZA },
  { key: 'planDeCobro', es: 'Plan de cobro', en: 'Billing Plan', tipo: 'lista', opciones: PLAN_DE_COBRO },
  { key: 'formaDePago', es: 'Forma de pago', en: 'Payment Option', tipo: 'lista', opciones: FORMA_DE_PAGO },
  { key: 'sinPapeles', es: '¿Sin papeles (todo digital)?', en: 'Paperless', tipo: 'lista', opciones: SI_O_NO },
  { key: 'coberturaCompleta', es: '¿Cobertura completa?', en: 'Full Coverage', tipo: 'lista', opciones: SI_O_NO },
  { key: 'pip', es: '¿PIP?', en: 'PIP', tipo: 'lista', opciones: SI_O_NO },
  { key: 'telematica', es: '¿Programa de telemática?', en: 'Telematics Program', tipo: 'lista', opciones: SI_O_NO },
];

/**
 * El bloque de PAGO.
 *
 * El CVC NO ESTA AQUI, y no es un olvido: guardar el codigo de seguridad de una
 * tarjeta esta prohibido por las reglas de las tarjetas (PCI-DSS, requisito
 * 3.2), cifrado o sin cifrar. Deskte ya lo tenia decidido asi — lo dice el
 * modelo `ClientPaymentMethod` del esquema desde antes de esto—, y este
 * formulario entra por un enlace publico y sin sesion, que es el peor sitio
 * posible para estrenar una excepcion.
 *
 * El resto de los numeros —tarjeta, cuenta y ruta— si se guardan, pero como se
 * guardan siempre en Deskte: cifrados, detras del PIN y con registro de quien
 * los mira. Ver `pagoParaGuardar`.
 */
export const CAMPOS_PAGO = [
  { key: 'formaDePago', es: 'Forma de pago', en: 'Payment Option', tipo: 'lista', opciones: FORMA_DE_PAGO },
  { key: 'nombreEnTarjeta', es: 'Nombre en la tarjeta', en: 'Name on Card', tipo: 'texto' },
  { key: 'tarjeta', es: 'Tipo de tarjeta', en: 'Card', tipo: 'texto' },
  { key: 'numeroTarjeta', es: 'Número de tarjeta', en: 'Card Number', tipo: 'texto' },
  { key: 'vencimientoTarjeta', es: 'Vencimiento (MM/AA)', en: 'Exp Date (MM/YY)', tipo: 'texto' },
  { key: 'banco', es: 'Banco', en: 'Bank Name', tipo: 'texto' },
  { key: 'ruta', es: 'Número de ruta (routing)', en: 'Routing Number', tipo: 'texto' },
  { key: 'cuenta', es: 'Número de cuenta', en: 'Account Number', tipo: 'texto' },
];

/** Las secciones de auto, con su clave de plantilla y sus campos. */
export const SECCIONES_DE_AUTO = [
  { key: 'autoDriver', es: 'Datos del conductor', en: 'Driver information', campos: CAMPOS_CONDUCTOR_TITULAR, enDireccion: CAMPOS_CON_LA_DIRECCION, retirados: CAMPOS_CONDUCTOR_TITULAR_RETIRADOS },
  { key: 'vehicles', es: 'Carros', en: 'Cars', campos: CAMPOS_CARRO, repetidor: true },
  { key: 'autoDrivers', es: 'Conductores adicionales', en: 'Additional drivers', campos: CAMPOS_CONDUCTOR, repetidor: true, retirados: CAMPOS_CONDUCTOR_RETIRADOS },
  { key: 'previousAddresses', es: 'Direcciones anteriores', en: 'Previous addresses', campos: CAMPOS_DIRECCION_ANTERIOR, repetidor: true },
  { key: 'currentInsurance', es: 'Seguro actual', en: 'Current insurance', campos: CAMPOS_SEGURO_ACTUAL },
  { key: 'autoPolicy', es: 'Preferencias de la póliza', en: 'Policy preferences', campos: CAMPOS_POLIZA_AUTO },
  { key: 'payment', es: 'Información de pago', en: 'Payment information', campos: CAMPOS_PAGO },
];

/** Las claves de seccion que trae el formulario de auto. */
export const CLAVES_DE_AUTO = SECCIONES_DE_AUTO.map((s) => s.key);

/** Las que son listas repetibles: de estas se puede agregar otra fila. */
export const CLAVES_REPETIBLES = SECCIONES_DE_AUTO.filter((s) => s.repetidor).map((s) => s.key);

/** Una fila vacia de un repetidor, con todas sus claves puestas en "". */
export function filaVacia(campos) {
  const out = {};
  for (const c of (campos || [])) out[c.key] = '';
  return out;
}

/** ¿Esta fila la empezo a llenar alguien? Una fila en blanco no se envia. */
export function filaEmpezada(fila, campos) {
  if (!fila) return false;
  return (campos || []).some((c) => String(fila[c.key] ?? '').trim());
}

/**
 * Las filas que SI se envian: solo las empezadas, y con las claves del
 * catalogo. Cualquier cosa que llegue de mas se queda fuera.
 */
export function filasQueSeEnvian(lista, campos) {
  return (lista || [])
    .filter((f) => filaEmpezada(f, campos))
    .map((f) => {
      const out = {};
      for (const c of (campos || [])) {
        const v = String(f[c.key] ?? '').trim();
        if (v) out[c.key] = v;
      }
      return out;
    });
}

/** La etiqueta de un campo o de una opcion, en el idioma del formulario. */
export function etiqueta(def, lang) {
  if (!def) return '';
  return (lang === 'en' ? def.en : def.es) || def.en || def.es || '';
}

/**
 * Los campos que una seccion PREGUNTA hoy, esten donde esten en la pantalla.
 *
 * Los de vivienda se pintan dentro de "Direccion", pero siguen siendo del
 * bloque del conductor: se guardan ahi y de ahi se leen. Cualquier sitio que
 * necesite "todo lo que este bloque pide" tiene que usar esto y no `campos`,
 * o esos tres se pierden en silencio al enviar.
 */
export function camposDelBloque(sec) {
  if (!sec) return [];
  return [...(sec.campos || []), ...(sec.enDireccion || [])];
}

/**
 * Lo anterior MAS los retirados: para la pantalla que ENSEÑA una aplicacion
 * ya enviada. Una aplicacion mandada antes de quitar un campo lo trae escrito,
 * y esa pantalla pinta desde el catalogo — sin esto el dato se queda guardado
 * en la base y desaparece de la vista de quien la abre.
 */
export function camposParaVer(sec) {
  return [...camposDelBloque(sec), ...((sec && sec.retirados) || [])];
}

/**
 * ¿Los de vivienda se pintan arriba, con la direccion?
 *
 * Solo si la seccion de Direccion esta encendida en esa plantilla. Si esta
 * apagada, se quedan donde estaban —con el conductor— en vez de desaparecer:
 * un campo que deja de preguntarse porque se apago OTRA seccion es una
 * pregunta perdida sin que nadie lo note.
 */
export function viviendaVaConLaDireccion(secciones) {
  return !!(secciones && secciones.address);
}
